/**
 * Order Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrderItemPageVO { 
    /**
     * id
     */
    id?: number;
    /**
     * Product Name
     */
    spuName?: string;
    /**
     * Product Code
     */
    spuCode?: string;
    /**
     * skuCode
     */
    skuCode?: string;
    /**
     * SKU Name
     */
    skuName?: string;
    /**
     * Refunded
     */
    refundFlag?: number;
    /**
     * Quantity
     */
    quantity?: number;
    /**
     * Refunded quantity
     */
    refundQty?: number;
    /**
     * Returned quantity
     */
    returnQty?: number;
    /**
     * Third-party sales unit price
     */
    thirdSaleAmount?: number;
    /**
     * Third-party apportioned total price
     */
    outBalancePrice?: number;
    /**
     * Internal sales price
     */
    innerSalePrice?: number;
    /**
     * Internal apportioned price
     */
    innerBalancePrice?: number;
    /**
     * Internal sales unit price
     */
    innerSingleSaleAmount?: number;
    /**
     * Cost
     */
    costAmount?: number;
    /**
     * Total cost
     */
    totalCostAmount?: number;
    /**
     * Freight
     */
    transPrice?: number;
    /**
     * Shipping status
     */
    deliveryStatus?: string;
    /**
     * Preemption status
     */
    preemptionStatus?: string;
    /**
     * Sourcing status
     */
    sourceStatus?: string;
    /**
     * Package identification: 0-single product, 1-package
     */
    setFlag?: number;
    /**
     * Package fulfillment mode
     */
    fulfillmentMode?: OrderItemPageVO.FulfillmentModeEnum;
    /**
     * Gift flag: 0-sale item, 1-gift
     */
    giftFlag?: number;
    /**
     * Aggregated product line, preemption channel warehouse quantity synchronization platform status
     */
    syncPreempStatus?: string;
    /**
     * Aggregated product line, shipping (receiving) synchronization platform status
     */
    syncDeliveryStatus?: string;
    /**
     * Order level - pending status
     */
    suspendStatus?: string;
    /**
     * Receiving status
     */
    receivingStatus?: string;
    /**
     * Tags, multiple separated by commas
     */
    tags?: string;
}
export namespace OrderItemPageVO {
    export const FulfillmentModeEnum = {
        VirtualBundle: 'VIRTUAL_BUNDLE',
        PrePacked: 'PRE_PACKED'
    } as const;
    export type FulfillmentModeEnum = typeof FulfillmentModeEnum[keyof typeof FulfillmentModeEnum];
}


